import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import Contratos from '../../Documentos/Contratos';
import Timestamp from '../../Timestamp/Timestamp';
import { mergeQuery } from '../../../helpers/querystring';

const ContratosTemplate = (data) => {
  const { items, query } = data;
  const location = useLocation();
  const pathname = location.pathname;
  const newQuery = mergeQuery(location, query);
  return (
    <>
      <div className="items contratos-template">
        <Timestamp />
        <Contratos
          documentos={items}
          params={newQuery}
          url={pathname}
          allowExport={true}
        />
      </div>
    </>
  );
};

ContratosTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  isEditMode: PropTypes.bool,
};

export default ContratosTemplate;
